import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=9c0e7eaa&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c0e7eaa')) {
      api.createRecord('9c0e7eaa', component.options)
    } else {
      api.reload('9c0e7eaa', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=9c0e7eaa&", function () {
      api.rerender('9c0e7eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qfFM4lpQUeEi/JS/comp/ImgFallback.vue"
export default component.exports